import React,{ useState, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { firestore } from '../../../configs/environments/firebase/firebaseApp';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import ExpIconBottom from '../../ExpIconBottom';
import InfoCardOpinion from './InfoCardOpinion'
import ModalOpinion from '../CardValoration/ModalOpinion';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import Snackbar from '../../Snackbar';
import axios from 'axios';
import './cardOpinion.scss';

const CardOpion = ({ authClient, opinions, client, rate, showLoading, hideLoading }) => {
  let [rests, setRests] = useState([])
  const [ isThree, setIsThree ] = useState(false)
  
  useEffect(()=>{
    authClient && authClient.uid && process_opinion(authClient.uid)
    if ((rests && rests.length >= 3) || (opinions && opinions.length >= 3)) {
      setIsThree(true)
    }
  },[authClient, opinions, rests])

  async function process_opinion(uid) {
    let wholeData = []  
    let mesRef =  firestore
        .collection("opinions").doc(uid)
        .collection('opinion').orderBy('createdAt', 'desc')
    await mesRef.get()
        .then(querySnapshot =>{
          querySnapshot.forEach(function(doc) {
           // doc.data() is never undefined for query doc snapshots
          wholeData.push(doc.data())
          });
        })
        .catch(error=>{})
    setRests(wholeData);
  }

  const [ openModal, setOpenModal ] = useState(false);

  const [ feedbackMessage, setFeedbackMessage ] = useState({
    open: false,
    message: '',
    variant: 'info'
  });

  const onPreview = useRouteMatch('/preview');
  const clientLogged = client && client.role === 'cliente';
  const lawyerLogged = client && (client.role === 'lawyer' || client.role === 'lawFirm' );

  const handleOpenModal = () => {
    if (clientLogged){
      setOpenModal(true)
    } else if (lawyerLogged || onPreview) {
      setOpenModal(false)
    }else {
      setOpenModal(true)
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'info'
    });
  };

  const formValues = {
    opinion: '',
    rating: 0.5,
  };

  const handleSubmit = (values, { setSubmitting, setFieldError, setFieldValue }) => {
    
    showLoading(); 
    setSubmitting(false);
    let uid = authClient && authClient.role === "lawyer" && authClient.idLawFirm && authClient.idLawFirm !== undefined ? authClient.idLawFirm : 'no-uid';
    let clientMes = client.uid ? client.uid : '';
    let data =  {
      "clientUid": clientMes,
      "lawyerUid": authClient.uid,
      "role": authClient.role,
      "opinion": values.opinion,
      "rating": values.rating === 0 ? 0.5 : values.rating,
      "type":"Opinion",
      "messageNotification":{
          "title": authClient.displayName ? authClient.displayName : (`${authClient.name} ${authClient.lastName} `),
          "text": "Ha dejado una opinión de tus servicios.",
          "instruction": "Para ver la opinión, da click en la notificacion de tu perfil."
      },
      "typeAnalitics":"formOpinion",
      "idLawFirm": uid
    }

    // Pasar la url , la data y  el header(tipo de contenido = json)
    axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/create/create_data`, data, {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*"
      }
    })
    .then(res=>{
      let rateNew;
      console.log("0rate", rate)
      console.log("0values.rating", values.rating)
      if(rate === 0 || values.rating === 0){
        console.log("rate", rate)
        console.log("values.rating", values.rating)

        rateNew = parseFloat(rate) + parseFloat(values.rating)
      } else {
        console.log("2rate", rate)
        console.log("2values.rating", values.rating)
        rateNew = (parseFloat(rate) + parseFloat(values.rating)) /2
      }
      console.log('rateNew',rateNew)
      let totalRate = Number(rateNew).toFixed(1)
      console.log('totalRate',totalRate)
     
      firestore
        .collection('lawyerUsers')
        .doc(authClient.uid) //.set({ lawyers: [{ ...values, imgProfile }] }, { merge: true })
        .set({
          analytics: {
            opinion: {
              qualification: totalRate,
              counts: opinions.length + 1 
            }}
          }, { merge: true }).then(res=>{
                  handleCloseModal()
                hideLoading();
                setFeedbackMessage({
                  open: true,
                  message: 'Se ha enviado la opinion con éxito',
                  variant: 'success'
                });
                // window.location.reload();
          })
        })  
  };

  return (
    <>
      <ModalOpinion
        open={openModal}
        authClient={authClient}
        handleClose={handleCloseModal}
        clientLogged={clientLogged}
        formValues={formValues}
        handleSubmit={handleSubmit}
      />
      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '8px' : '80px'}
      />
      <ExpIconBottom
        title="Opiniones"
        length={
          rests ? rests.length :
          opinions ? opinions.length : 0
        }
        sumcontent={
          <>
            {rests && rests ? (rests.map((item, index) => {
                  if (!item.visible) {
                    return null
                  }
                  return (
                    <InfoCardOpinion key={index} item={item}/>
                  )
                } 
              )
            )
             : (opinions && opinions.map((item, index)=> {
              if (!item.visible) {
                return null
              }
              return (
                <InfoCardOpinion key={index} item={item}/>
              ) 
            }
            ))
            }     
          </>
        }
        button="Recomendar"
        hideButton={onPreview}
        buttonFunction={handleOpenModal}
        scrollable={isThree}
      />
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

const mapStateToProps = state => ({
  client: state.authClient,
})

export default connect(mapStateToProps, mapDispatchToProps)(CardOpion);
